export const name = 'TemplateUploadController';
export default function TemplateUploadController($mdDialog, $scope, $log, templatesService,L10NFilter, errorDialogOpen) {
    //noinspection BadExpressionStatementJS
    'ngInject';

    var vm = this;

    vm.uploadTemplate = uploadTemplate;
    vm.selectedFile = {};
    vm.fileSelected = fileSelected;
    vm.onFileSelect = onFileSelect;
    vm.showDropArea = true;
    vm.showProgressBar = false;
    vm.uploadProgress = 0;
    vm.uploadProgressCallback = uploadProgressCallback;
    vm.knownProgress = false;
    vm.loadInProgress = false;
    vm.isFileSelectedFlag = false;
    vm.cancel = cancel;
    vm.uploadContoller = {cancel:false};
    vm.selectedFileName = '';
    vm.closeDialogFromOutsideHelperObject.RegisterOnCloseCallback(closeCalledFromOutside);

    if(vm.fileUploadProps){
      vm.selectedFile = vm.fileUploadProps.fileSelected;
      uploadTemplate();
    }

    function closeCalledFromOutside(){
        $mdDialog.cancel();
    }

    function fileSelected(selectedFile){
        vm.selectedFile = selectedFile;
    }

    function onFileSelect($files){
        vm.isFileSelectedFlag = true;
        fileSelected($files[0]);
    }

    function uploadProgressCallback(uploadReportPercentage, templateId = null){
        if(templateId){
            vm.templateId = templateId;
        }

        if(uploadReportPercentage){
            vm.uploadProgress = uploadReportPercentage;
            vm.knownProgress = true;
            if(uploadReportPercentage === 100){
                vm.knownProgress = false;
            }
            $scope.$apply();
        }
    }

    function cancel(){
        vm.uploadContoller.cancel = true;

        if(vm.templateId){
            templatesService.deleteTemplate(vm.templateId);
        }

        $mdDialog.cancel();
    }

    function uploadTemplate() {
      var functionName='TemplateUploadController.uploadTemplate';
      $log.info(angular.toJson({action:'function called', functionName:functionName, fileName:vm.selectedFile.name}));

      vm.showDropArea = false;
      vm.showProgressBar = true;
      vm.loadInProgress = true;

      let templateEntryCreationRequest = {
        templateName:vm.selectedFile.name.substr(0, vm.selectedFile.name.lastIndexOf('.'))
      };

      vm.selectedFileName = templateEntryCreationRequest.templateName;

      templatesService.uploadTemplate(vm.selectedFile, templateEntryCreationRequest,vm.templateList, uploadProgressCallback, null, vm.uploadContoller).then(
        function (postUploadTemplate) {
          $log.info(angular.toJson({action:'file uploaded successfully', functionName:functionName}));

          $mdDialog.hide(postUploadTemplate);
        }, function(status) {
          $log.info(angular.toJson({action:'error uploading file', functionName:functionName}));
          $mdDialog.cancel();

          errorDialogOpen.openErrorDialog(status);

        });

      $log.info(angular.toJson({action:'function return', functionName:functionName}));
    }
}
